import React from 'react';
import {
    CarouselUtil,
    InlineCarouselContainer,
    ModalCarouselContainer,
} from '@homeaway/react-image-carousel';
import analytics from '../../../helpers/analytics';
import constants from '../../../helpers/constants';
import CarouselButtonsDesktop from '../../../../universal/components/listing-info/image-carousel/carousel-buttons-desktop';
import utility from '../../../helpers/utility';
import egtnlUtil from '../../../helpers/egtnl-util';

class CarouselContainer extends React.Component {
    static defaultProps = {
        index: 0,
        countPerSide: 1,
        slideSize: 'height',
        images: [],
        isInline: false,
        headline: '',
    };

    constructor(props) {
        super(props);

        const {index, countPerSide, images} = this.props;
        const i = index || 0;
        this.state = {
            index: i,
            renderedIndices: CarouselUtil.getRenderIndices(
                images.length,
                i,
                countPerSide
            ),
        };

        this.onPrevImage = this.getPrevNextFunc('prev').bind(this);
        this.onNextImage = this.getPrevNextFunc('next').bind(this);
    }

    getPrevNextFunc(dir) {
        const {countPerSide} = this.props;
        return (index = 0, length = this.carouselData.length) => {
            this.props.countClickedImages(index);
            if (dir === 'next') {
                analytics.genericEvent('carousel next clicked');
            } else {
                analytics.genericEvent('carousel prev clicked');
            }
            const i =
                dir === 'next'
                    ? CarouselUtil.getNextIndex(index, length)
                    : CarouselUtil.getPrevIndex(index, length);
            this.setState({
                index: i,
                renderedIndices: CarouselUtil.getRenderIndices(
                    length,
                    i,
                    countPerSide
                ),
            });
        };
    }

    render() {
        const {...rest} = this.state;
        const {images, fullScreen, headline} = this.props;
        const isMobile = utility.isMobileViewport();
        const isSmallerSizeEnabled =
            egtnlUtil.isTabletMobileSmallerSizeEnabled();

        const totalImages = images?.length || 0;
        const locationName = headline || 'Unclassified location';
        const imageAltText = (image, index) => {
            return image.altText
                ? image.altText
                : `${locationName}, ${index + 1} of ${totalImages}`;
        };

        const imagesData = images.map((image, index) => ({
            src: image.c10_uri,
            lowResSrc: image.c5_uri,
            altText: imageAltText(image, index),
            width: 640,
            height: 480,
        }));

        const mobileImagesData = images.map((image, index) => ({
            src: fullScreen ? image.c10_uri : image.c8_uri,
            lowResSrc: image.c5_uri,
            altText: imageAltText(image, index),
        }));

        return (
            <div
                className="carousel-modal-open"
                id={
                    this.props.isInline
                        ? 'carousel-modal-open-inline'
                        : 'carousel-modal-open'
                }
                {...(!this.props.isInline && {
                    'aria-label': 'image preview in fullscreen',
                })}
            >
                {this.props.isInline && (
                    <InlineCarouselContainer
                        key="modal-container"
                        images={
                            isSmallerSizeEnabled ? mobileImagesData : imagesData
                        }
                        onPrevImage={this.onPrevImage}
                        onNextImage={this.onNextImage}
                        onClose={this.props.onClose}
                        slideSize="contain"
                        thumbnailUrl={''}
                        renderButtons={CarouselButtonsDesktop}
                        overlayColor={constants.IMAGE_CAROUSEL.OVERLAY_COLOR}
                        showArrows
                        countClickedImages={this.props.countClickedImages}
                        fullScreen={this.props.fullScreen}
                        {...rest}
                    />
                )}
                {!this.props.isInline && isMobile && (
                    <ModalCarouselContainer
                        key="modal-container"
                        images={imagesData}
                        onPrevImage={this.onPrevImage}
                        onNextImage={this.onNextImage}
                        onClose={this.props.onClose}
                        slideSize="contain"
                        overlayColor={constants.IMAGE_CAROUSEL.OVERLAY_COLOR}
                        showArrows
                        countClickedImages={this.props.countClickedImages}
                        fullScreen={this.props.fullScreen}
                        handlesKeyboardNavigation={this.props.fullScreen}
                        {...rest}
                    />
                )}
                {!this.props.isInline && !isMobile && (
                    <ModalCarouselContainer
                        renderButtons={CarouselButtonsDesktop}
                        key="modal-container"
                        images={imagesData}
                        onPrevImage={this.onPrevImage}
                        onNextImage={this.onNextImage}
                        onClose={this.props.onClose}
                        slideSize="contain"
                        overlayColor={constants.IMAGE_CAROUSEL.OVERLAY_COLOR}
                        showArrows
                        countClickedImages={this.props.countClickedImages}
                        fullScreen={this.props.fullScreen}
                        handlesKeyboardNavigation={this.props.fullScreen}
                        {...rest}
                    />
                )}
            </div>
        );
    }
}

export default CarouselContainer;
